import React, { useContext } from "react";

import { graphql } from "react-relay";
import SelectSport from "./SelectSport";
import {
  GreenMachineContext,
  GreenMachineProvider,
} from "./GreenMachineContext";
import SelectSlate from "./SelectSlate";
import SelectGameType from "./SelectGameType";
import SelectPlayers from "./SelectPlayers";
import SelectExposures from "./SelectExposures";
import ViewLineups from "./ViewLineupsPage/ViewLineups";
import GreenMachineError from "./GreenMachineError";
import LineupConfiguration from "./LineupConfiguration";
import "./GreenMachinePage.css";
import { gql, useQuery } from "@apollo/client";
import { isSiteAdmin } from "../../../../AuthUtils";
import Button from "../../../Button";
import WarningBanner from "../../../WarningBanner";
import ConfigureRules from "./ConfigureRules";
import ViewLineupsPage from "./ViewLineupsPage";
import { Redirect } from "react-router-dom";
import SelectSessionPage from "./SelectSessionPage";
import GreenMachineErrorReportsPage from "./GreenMachineErrorReportsPage";
import GreenMachineErrorReportsButton from "./GreenMachineErrorReportsPage/GreenMachineErrorReportsButton";
import StepHeading from "./StepHeading";
import ChevronBar from "./ChevronBar";

const GET_WHO_AMI = gql`
  query GreenMachinePageWhoAmIQuery {
    whoAmI {
      groups {
        name
      }
      username
    }
  }
`;

export default function GreenMachinePage() {
  const { loading, error, data } = useQuery(GET_WHO_AMI);

  if (!loading) {
    if (!data.whoAmI) {
      return <Redirect to={"/memberships"} />;
    }
  }

  return (
    <GreenMachineProvider>
      <WarningBanner active={false}>
        <strong>
          If you&apos;re building lineups for the Zurich Classic, make sure that
          you only select 1 player per team for your player pool. Draftkings
          lists both players separately, but will not accept lineups that
          include both players from a single team. The Green Machine will not
          prevent this from happening if two players from the same team are
          selected for your pool.
        </strong>
      </WarningBanner>
      <div className="green-machine-container">
        <div className="gm-page-header">
          <h1 className="gm-page-title">Green Machine</h1>
          {!loading && !error ? (
            <div className="gm-page-header-actions">
              {data.whoAmI.username === "bgould96" ? (
                <GreenMachineErrorReportsButton />
              ) : null}
              {isSiteAdmin(data.whoAmI.groups) ? (
                <Button href="/tools/green-machine/admin">Upload Percs</Button>
              ) : null}
            </div>
          ) : null}
        </div>
        <GreenMachineErrorReportsPage />
        <ChevronBar />
        <StepHeading />
        <SelectSport />
        <GreenMachineError />
        <SelectGameType />
        <SelectSlate />
        <SelectSessionPage />
        <LineupConfiguration />
        <SelectPlayers />
        <React.Suspense
          fallback={
            <div className="gm-configure-rules-container">
              Loading configure rules...
            </div>
          }
        >
          <ConfigureRules />
        </React.Suspense>
        <SelectExposures />
        <ViewLineupsPage />
      </div>
    </GreenMachineProvider>
  );
}
